export const WebhooksTableColumns = [
    { id: "name",          labelEn: "Name",        labelAr: "الاسم",         align: "left",   sortable: true },
    { id: "url",           labelEn: "URL",         labelAr: "الرابط",        align: "left",   sortable: false },
    { id: "events",        labelEn: "Events",      labelAr: "الأحداث",       align: "center", sortable: false },
    { id: "is_active",     labelEn: "Active",      labelAr: "مُفعّل",        align: "center", sortable: true },
    { id: "last_status",   labelEn: "Last status", labelAr: "آخر حالة",      align: "center", sortable: false },
    { id: "last_fired_at", labelEn: "Last fired",  labelAr: "آخر تشغيل",     align: "center", sortable: true },
];
